/* eslint-disable @typescript-eslint/no-explicit-any */
// export interface Filters {
//   priceRange?: number | number[];
//   page?: number;
//   search: string;
//   limit?: number;
//   ratingValues?: number | null;
//   state: string;
// }

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export interface FetchSearchDataParams {
  filter: Record<string, any>; // Adjust this type based on your API's expected filter structure
}

export interface FetchSearchDataResponse {
  data: any; // Replace `any` with the actual data structure returned by your API
}

export interface SlideProps {
  image: string;
  title: string;
  description: string;
  button?: string;
}

export interface SubCategoriesResponse {
  success: boolean;
  subCategories: SubCategory[];
  total: number;
  page: number;
  pages: number;
}

export interface CategoriesResponse {
  success: boolean;
  categories: Category[];
  total: number;
  page: number;
  pages: number;
}

export interface CategoriesAndSubResponse {
  success: boolean;
  categoriesWithSubCategories: CategoryWithSub[];
  total: number;
  page: number;
  pages: number;
}

export interface Filters {
  // keyword: string;
  search: string;
  categories: string[];
  subCategory: string | string[];
  // location: string;
  state: string;
  priceRange: [number, number] | null;
  ratings: number[];
  page?: number;
  latitude?: number | null;
  longitude?: number | null;
  radius?: number | null;
  address?: string | null;
  includeOnline?: boolean;
}

export interface SubCategory {
  subCategoryId: string;
  subCategoryName: string;
  subCategorySlug: string;
  categoryName: string;
  categoryId: string;
  createdAt: string;
  isFeatured: boolean;
  isCertificateRequired: boolean;
}

export interface Category {
  categoryId: string;
  categoryName: string;
  categorySlug: string;
  createdAt: string;
  isFeatured: boolean;
  isCertificateRequired: boolean;
}

export interface CategoryWithSub {
  categoryId: string;
  categoryName: string;
  categorySlug: string;
  categoryImage?: string;
  subCategories: SubCategory[];
  createdAt: string;
  isFeatured: boolean;
  isCertificateRequired: boolean;
}

export interface ServiceData {
  avg_rating: number;
  review_count: number;
  gallery: { serviceImages: string[] }[];
  serviceTitle: string;
  location: {
    city: string;
    state: string;
  }[];
  price: number;
  categoryId: string;
  serviceId: string;
  displayId?: string;
  slug: string;
  providerId: string;
}

// src/features/booking/types.ts

export interface StaffMember {
  id: string;
  name: string;
  email: string;
  serviceCount: number;
  rating: number;
  image: string;
  services?: string[]; // Array of service IDs this staff can perform
}

export interface Service {
  id: string;
  name: string;
  price: number;
  duration: number;
  rating: number;
  image: string;
  requiresStaff?: boolean; // Whether this service requires staff selection
}

// export interface DateTimeState {
//   selectedDate: string;
//   selectedFromTime: string;
//   selectedToTime: string;
//   timeSlotId: string;
//   selectedTime: string | null;
// }

export interface DateTimeState {
  selectedDate: string;
  selectedFromTime: string;
  selectedToTime: string;
  timeSlotId: string;
  selectedTime: string | null;
  selectedStaff: string;
  selectStaffId: string;
}

export interface StaffState {
  // selectedStaff: StaffMember | null;
  selectedStaff: string;
  selectAnyone: boolean;
  allStaff: StaffMember[];
  availableStaff?: StaffMember[]; // Staff available for selected service
  isStaffAvilableInDay?: boolean; // Flag to check if staff is available on selected date
  isStaffAvilableInService?: boolean; // Flag to check if staff is available on selected time
}

export interface ServicesState {
  // selectedServices: string[];
  // allServices: Service[];
  // additionalServices: AdditionalServiceData[];
  serviceBasicDetails: ServiceBasicDetails[];
}

export interface PersonalInfo {
  addressId?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  notes: string;
  address_line_1?: unknown;
  error: boolean;
}

// export interface BookingState {
//   currentStep: number;
//   dateTime: DateTimeState;
//   staff: StaffState;
//   services: ServicesState;
//   personalInfo: PersonalInfo;
//   selectedService?: Service | null;
// }

export interface AdditionalServiceData {
  id: string;
  price: number;
  serviceItem: number;
  images: string;
}

export interface IPackageProps {
  // isSoldOut: boolean;
  // isDiscount: boolean;
  // packageName: string;
  // price: number;
  // includes?: {
  //   input1?: string;
  //   input2?: string;
  //   input3?: string;
  //   input4?: string;
  // };
  // discount?: {
  //   isDiscount?: boolean;
  //   discountType: 'general-discount';
  //   valueType: 'amount' | 'percentage';
  //   durationType: 'life-time' | 'time-base';
  //   amount: number;
  //   duration: {
  //     start: string;
  //     end?: string;
  //   };
  //   maxCount?: number;
  // };

  isSoldOut: boolean;
  packageId: string;
  serviceId: string;
  providerId: string;
  isDiscount: boolean;
  packageName: string;
  price: number;
  includes?: string[];
  discount: {
    discountId: string;
    serviceId: string;
    serviceName: string;
    packageId: string;
    packageName: string;
    providerId: string;
    isDiscount: boolean;
    discountType: 'general-discount';
    valueType: 'amount' | 'percentage';
    durationType: 'life-time' | 'time-base';
    amount: number;
    duration: {
      start: string;
      end: string;
    };
    maxCount: number;
    createdBy: string;
    isPackageDiscount: boolean;
    acceptAllUserIds: string[];
    createdAt: string;
    updatedAt: string;
  };
}

export interface IDiscountAddProps {
  serviceId: string;
  isDiscount: boolean;
  discountType: 'promo-code' | 'general-discount';
  valueType: 'amount' | 'percentage';
  durationType: 'life-time' | 'time-base';
  amount: number;
  duration: {
    start: string;
    end?: string;
  };
  promoCode?: string;
  maxCount?: number;
}

export interface ServiceBasicDetails {
  serviceId: string;
  providerId: string;
  serviceTitle: string;
  categoryId: string;
  subCategoryId: string;
  price: number;
  isOffers: boolean;
  isAdditional: boolean;
  serviceImages: string;
  city: string;
  state: string;
  country: string;
  staff: string;
  referenceCode?: string;
  availableDate: [];
  packages: IPackageProps[];
  discount: IDiscountAddProps;
}

export type Address = {
  isLegalAddress?: boolean;
  addressId?: string;
  addressLine1?: string;
  country?: string;
  state?: string;
  city?: string;
  postalCode?: string;
};

export type TwoFactor = {
  IsTwoFactorEnabled: boolean;
  lastUpdatedAt?: string | null;
};

export type Password = {
  IsPasswordReset: boolean;
  lastUpdatedAt?: string | null;
};

export type ProviderData = {
  userId: string;
  IsIndividual: boolean;
  IsBusiness: boolean;
  enterpriseId?: string | null;
  name: string;
  email: string;
  mobile?: string;
  dateOfBirth?: string;
  groupRole?: string;
  bio?: string;
  address?: Address;
  currencyCode?: string;
  language?: string;
  profilePicture?: string;
  ISVerified?: boolean;
  providerStatus?: string;
  IsDocUploaded?: boolean;
  IsDocReviewed?: boolean;
  IsDocVerified?: boolean;
  twoFactorEnabled?: TwoFactor;
  password?: Password;
  IsAgreed?: boolean;
  IsActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export interface RecentSearchLocation {
  formatted: string;
  address_line1: string;
  address_line2: string;
  lat: number;
  lon: number;
  timestamp: number;
}

export interface AddressSuggestion {
  properties?: {
    formatted: string;
    address_line1: string;
    address_line2: string;
    lat: number;
    lon: number;
  };
  formatted: string;
  address_line1?: string;
  address_line2?: string;
  lat: number;
  lon: number;
  timestamp?: number;
}

// PACKAGE
export interface IPackageProps {
  isSoldOut: boolean;
  isDiscount: boolean;
  packageId: string;
  packageName: string;
  price: number;
  // includes?: {
  //   input1?: string;
  //   input2?: string;
  //   input3?: string;
  //   input4?: string;
  // };
  // discount?: {
  //   discountId: string;
  //   isDiscount?: boolean;
  //   discountType: 'general-discount';
  //   valueType: 'amount' | 'percentage';
  //   durationType: 'life-time' | 'time-base';
  //   amount: number;
  //   duration: {
  //     start: string;
  //     end?: string;
  //   };
  //   maxCount?: number;
  // };
}

// BOOKING
export interface ServiceState {
  serviceId: string;
  packageId: string;
  isPackage: boolean;
  date?: string;
  fromTime: string;
  toTime: string;
  timeSlotId: string;
  staffId: string;
  addtionalServiceIds: string[];

  personalInfo: {
    addressId: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    streetAddress: string;
    city: string;
    state: string;
    postalCode: string;
    notes: string;
    error: boolean;
  };
}

export interface BookingState {
  booking: ServiceState;
}

export type PersonalGet = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: {
    addressId?: string;
    street: string;
    city: string;
    state: string;
    postalCode: string;
  };
  bookingNotes?: string;
};

export interface TimeSlotGet {
  timeSlotId: string;
  from: string;
  to: string;
  availableStaff: [
    {
      staffId: string;
      fullName: string;
      providerStaffId: string;
      isProvider: boolean;
    },
  ];
}

/**
 * Phase 3.1 — one additional service assigned to specific session(s) of a
 * package tier/offer/CustomerPackage. `sessionNumbers` are 1-based positions
 * within the tier's `sessionCount` (sessionCount 3 → valid values 1, 2, 3).
 * `serviceItem`/`price` are a snapshot taken at purchase/offer time (so a
 * later edit to the service's addon pricing never rewrites a historical
 * package) — both optional since older/legacy entries may omit them.
 */
export interface SessionAddOn {
  additionalServiceId: string;
  serviceItem?: string;
  price?: number;
  sessionNumbers: number[];
}

export interface AdditionalGet {
  /** Present when a response formats add-ons via `id` (e.g. jobService.js's
   * formatAdditionalServices). The public service-fetch response used by
   * the quote form and credit-session booking instead returns the raw
   * populated AdditionalService document — no `id`, use
   * `additionalServiceId` there. Both are optional here since neither
   * response guarantees the other. */
  id?: string;
  additionalServiceId?: string;
  price: number;
  serviceItem: string;
  images: string;
  sessionNumbers?: number[];
}

export interface TomeSlotGet {
  from: string;
  to: string;
  maxBookings: number;
  availableSlots: number;
  booked: number;
}
export interface AvailabilityGet {
  id: string;
  day: string;
  timeSlots: TomeSlotGet[];
  alldate: boolean;
}

export interface LocationGet {
  id: string;
  address: string;
  city: string;
  state: string;
  country: 'Canada' | 'canada' | 'ca' | 'CA';
  pinCode: string;
  googleMapsPlaceId?: string;
  latitude?: number;
  longitude?: number;
}

export interface GalleryGet {
  id: string;
  serviceImages: string[];
  serviceVideo?: string[];
  videoLink?: string;
}

export interface SeoGet {
  id: string;
  metaTitle: string;
  metaKeywords: string[];
  metaDescription: string;
}

export interface PackageGet {
  isSoldOut: boolean;
  packageId: string;
  serviceId: string;
  providerId: string;
  isDiscount: boolean;
  packageName: string;
  price: number;
  includes: string[];
  discount: {
    soldOut: boolean;
    discountId: string;
    serviceId: string;
    serviceName: string;
    packageId: string;
    packageName: string;
    providerId: string;
    isDiscount: boolean;
    discountType: 'promo-code' | 'general-discount';
    valueType: 'amount' | 'percentage';
    durationType: 'life-time' | 'time-base';
    amount: number;
    duration: {
      start: string;
      end: string;
    };
    maxCount: number;
    createdBy: string;
    isPackageDiscount: boolean;
    acceptAllUserIds: string[];
    createdAt: string;
    updatedAt: string;
  };
}

export interface DiscountGet {
  discountId: string;
  serviceId: string;
  serviceName: string;
  providerId: string;
  isDiscount: boolean;
  discountType: string;
  valueType: string;
  durationType: string;
  amount: number;
  duration: {
    start: string;
    end: string;
  };
  promoCode: string;
  maxCount: number;
  createdBy: string;
  isPackageDiscount: boolean;
  soldOut: boolean;
  acceptAllUserIds: string[];
  createdAt: string;
  updatedAt: string;
}
/**
 * PackageTier (Phase 3 — embedded subdocument array on ServiceInformation).
 * A provider defines one or more tiers (session count, price, validity,
 * one-time `block` vs recurring `monthly`) which a customer buys as a
 * CustomerPackage credit balance.
 */
export type PackageRecurrence = 'block' | 'monthly';

export interface PackageTier {
  _id?: string;
  name: string;
  description?: string;
  sessionCount: number;
  price: number;
  validityDays?: number;
  recurrence: PackageRecurrence;
}

/**
 * Job (Phase 2 — quote-based booking). A customer posts a scope/description,
 * the provider responds with a quote, and the job then runs through the
 * ENGAGEMENT_STATUS timeline (PascalCase values).
 */
export type JobStatus =
  | 'Requested'
  | 'Quoted'
  | 'ChangesRequested'
  | 'Accepted'
  | 'Scheduled'
  | 'InProgress'
  | 'Awaiting'
  | 'Completed'
  | 'Cancelled'
  | 'Declined'
  | 'Expired';

export type TimeframePreference = 'asap' | '2weeks' | 'month' | 'flexible';

export interface Job {
  jobId: string;
  displayId?: string;
  referenceCode?: string;
  customerId: string;
  providerId: string;
  businessId?: string;
  serviceId: string;
  serviceName?: string;
  serviceTitle?: string;
  /**
   * Parent multi-provider broadcast batch id, if this job was created as part
   * of one (quote-broadcast, PR #1618). Undefined for a regular 1:1 request.
   * The BE schema has always had this field (jobModel.js `batchId`) and
   * returns it on every read — it was simply never added to this type.
   */
  batchId?: string;
  scopeDescription: string;
  photos?: string[];
  location?: string;
  timeframePreference: TimeframePreference;
  budgetMin?: number;
  budgetMax?: number;
  quotedPrice?: number;
  addonSubtotal?: number;
  totalPrice?: number;
  total?: number;
  /**
   * ISO timestamp for when the provider's quote lapses, or `null` for legacy
   * quotes that predate the expiry field. The UI renders a countdown from this
   * value — clients never recompute the 7-day window themselves.
   */
  quoteExpiresAt?: string | null;
  estimatedDurationDays?: number;
  proposedStartDate?: string;
  proposedEndDate?: string;
  providerNotes?: string;
  scheduledStartDate?: string;
  status: JobStatus;
  bookingType: 'QUOTE';
  // Denormalised onto the job by `GET /v1/job/:id` (jobService.resolveProviderContact),
  // the same flat shape the booking detail response uses — see `providerEmail` /
  // `providerMobile` on the booking type below. Nullable: the lookup degrades to
  // null rather than failing the read when user-service is unavailable.
  providerName?: string | null;
  providerEmail?: string | null;
  providerMobile?: string | null;
  // The business behind this quote — flattened onto list jobs by
  // `GET /v1/job/customer` (jobService.getCustomerJobs) from the Business doc
  // for the job's businessId. Nullable like the provider contact fields above.
  businessName?: string | null;
  /**
   * Set once the customer reviews this job. Optional because jobs created
   * before the review feature have no such field — undefined reads as
   * "not yet reviewed", which is the correct default.
   */
  hasCusReviewed?: boolean;
  // Cancellation parity + completion confirmation (Phase-1 "include this
  // pass"). The BE records these when a customer cancels (`cancelledNote` is
  // the reason) or confirms a completed job. Optional: pre-existing jobs read
  // as undefined, which the UI treats as "not yet cancelled/confirmed".
  cancelledNote?: string;
  cancelledAt?: string;
  cancelledBy?: string;
  completionConfirmedAt?: string;
  completionConfirmedBy?: string;
  /** @deprecated Never populated by the API — use the flat fields above. */
  provider?: {
    name?: string;
    phone?: string;
    email?: string;
  };
  customer?: {
    name?: string;
  };
  service?: {
    title?: string;
  };
  additionalServices?: string;
  staff?: {
    id: string;
    name: string;
    email?: string;
  } | null;
  /**
   * Who initiated the engagement. 'provider' means the provider reached out to
   * the customer with a quote (as opposed to the customer posting a request).
   * Absent on legacy/pre-initiation jobs — reads as 'customer'.
   */
  initiatedBy?: 'provider' | 'customer';
  /**
   * ISO timestamp for when the provider's quote was sent. Undefined until
   * a quote is actually sent. The UI uses this to render a timeline step.
   */
  quotedAt?: string;
  /**
   * ISO timestamps for when each pipeline status was reached (the transition
   * moment, stamped by the backend): Accepted → acceptedAt, Scheduled →
   * scheduledAt, InProgress → inProgressAt, and completedAt when the provider
   * marks the work done (which opens the customer 'Awaiting' window).
   * Optional: legacy jobs created before a field existed read as undefined and
   * the timeline shows no date under that step.
   */
  acceptedAt?: string;
  scheduledAt?: string;
  inProgressAt?: string;
  completedAt?: string;
  /**
   * Line items breakdown for the quote. Populated when the provider includes
   * itemized details with quantity, unit price, and optional line totals.
   * Rendered as a read-only breakdown above the flat quotedPrice display.
   */
  lineItems?: Array<{
    description: string;
    quantity: number;
    unitPrice: number;
    multipliers?: Array<{ value: number; unit: string }>;
    lineTotal: number;
  }>;
  /**
   * Adjustment applied to the quote (e.g. loyalty discount, surcharge).
   * Includes the adjustment type, value, and reason text.
   */
  adjustment?: {
    type: string;
    value: number;
    reason?: string;
  };
  /**
   * Scope-prompt answers recorded during a provider-initiated call.
   * Only populated when job.initiatedBy === 'provider' and the provider
   * recorded call scope details via prompts.
   */
  promptAnswers?: Array<{
    promptId: string;
    label: string;
    promptText: string;
    answer: string;
  }>;
  /**
   * Structured quote fields (multi-provider quote-flow comparison view, S8
   * design; pms PR #813). All optional — absent means "not answered," never
   * a default or placeholder. `earliestStart` is a customer-facing
   * comparison signal, deliberately separate from the required
   * `proposedStartDate` above (which drives actual scheduling).
   */
  inclusions?: string[];
  exclusions?: string[];
  guarantee?: string;
  earliestStart?: string;
  /**
   * Derived, read-only, server-computed (never recompute client-side — see
   * pms PR #813). `itemised` is true only when `lineItems.length > 0`; a
   * flat `quotedPrice` alone is never itemised. `gapCount` is 5 minus however
   * many of the five booleans are true. Absent on legacy jobs that predate
   * the derivation would be unusual (the backend virtual/lean-path both
   * always compute it), but the S8 UI still guards for `undefined`.
   */
  quoteCompleteness?: {
    itemised: boolean;
    hasInclusions: boolean;
    hasExclusions: boolean;
    hasGuarantee: boolean;
    hasEarliestStart: boolean;
    gapCount: number;
  };
  /**
   * Payment schedule for staged payments (Phase 3 — backend pms PR adds this).
   * Present and mode === 'staged' only when the provider configured a payment plan.
   * A quote WITHOUT a staged schedule has no paymentSchedule field or mode: 'single' —
   * this is the normal case and the UI renders nothing extra.
   */
  paymentSchedule?: {
    sourceServiceId: string;
    sourceVersion: number;
    mode: 'single' | 'staged';
    currency: 'CAD';
    basisTotalMinor: number;
    frozenAt: string | null;
    stages: Array<{
      key: string;
      label: string;
      order: number;
      trigger:
        | 'on_acceptance'
        | 'provider_marks'
        | 'customer_approves'
        | 'on_completion';
      pctTenths: number;
      amountMinor: number;
      taxMinor: number;
      estimatedDate: string | null;
      isRemainderStage: boolean;
      status: 'pending' | 'reached';
      reachedAt: string | null;
    }>;
  };
  createdAt?: string;
  updatedAt?: string;
  /**
   * Quote negotiation thread (PR #869, gigmosaic-be-product-mgmt-service).
   * `currentRevisionNo` is the 1-based pointer into `QuoteRevision` history
   * (0 = no quote sent yet); `revisionCount` is the total revisions sent.
   * Both default to 0/undefined on legacy jobs predating this feature.
   */
  currentRevisionNo?: number;
  revisionCount?: number;
}

/** Attachment metadata returned by `POST /job/:id/thread/attachments`. */
export interface QuoteThreadAttachment {
  url: string;
  mimeType: string;
  fileName: string;
  sizeBytes: number;
}

/**
 * A single message in a Job's quote negotiation thread. The BE returns
 * `.lean()` Mongoose docs with no `toJSON` id transform, so the identity
 * field is `_id` (a plain ObjectId string), not `messageId` — verified
 * against `gigmosaic-be-product-mgmt-service` `jobService.js` (no global
 * mongoose id-rename plugin in that codebase).
 */
export interface QuoteThreadMessage {
  _id: string;
  jobId: string;
  revisionNo: number | null;
  authorRole: 'customer' | 'provider';
  authorUserId: string;
  authorBusinessId: string | null;
  body?: string;
  attachments: QuoteThreadAttachment[];
  createdAt: string;
}

/** `GET /job/:id/thread` response body's `thread` field. */
export interface JobThread {
  /**
   * Single source of truth for whether the thread can still be mutated —
   * derived server-side from `STATUS_META[job.status].isNegotiable`. Never
   * re-derive this from `job.status` client-side.
   */
  locked: boolean;
  lockedReason: JobStatus | null;
  messages: QuoteThreadMessage[];
}

/** One immutable snapshot from `GET /job/:id/revisions`, ascending by `revisionNo`. */
export interface QuoteRevision {
  _id: string;
  jobId: string;
  revisionNo: number;
  revisionType: 'initial' | 'revised';
  quotedBy: string;
  quotedAt: string;
  expiresAt: string;
  quotedPrice?: number;
  totalPrice?: number;
  total?: number;
  providerNotes?: string;
  createdAt: string;
}

/**
 * CustomerPackage (Phase 3 — a purchased credit balance against a Service's
 * PackageTier). `sessionsRemaining` is decremented as the customer books
 * sessions. `paymentStatus` starts 'PENDING' at purchase; an online (Stripe)
 * payment flips it to 'PAID' on capture or 'FAILED' on a declined/failed
 * charge — Cash on Hand leaves it 'PENDING' (settled offline).
 */
export type PackageOfferStatus =
  | 'PENDING_ACCEPTANCE'
  | 'ACTIVE'
  | 'DECLINED'
  | 'EXPIRED'
  | 'CANCELLED';
export interface CustomerPackage {
  customerPackageId: string;
  displayId?: string;
  customerId: string;
  providerId: string;
  businessId?: string;
  serviceId: string;
  tierId?: string;
  tier: PackageTier;
  sessionsRemaining: number;
  sessionsTotal: number;
  expiresAt?: string;
  autoRenew: boolean;
  paymentStatus: 'PENDING' | 'PAID' | 'FAILED';
  service?: {
    title?: string;
    serviceId?: string;
    displayId?: string;
    slug?: string;
  };
  // pms's customerPackageService.js formatAdditionalServices() always
  // returns an array ({id, serviceItem, price, images}, pre-filtered to
  // selected: true) — was previously typed as `string`, which does not
  // match the API and broke `tsc -b` (MyPackages.tsx:979's `.map()` call).
  additionalServices?: AdditionalGet[];
  addonSubtotal?: number;
  totalPrice?: number;
  total?: number;
  sessionAddOns?: SessionAddOn[];
  currentSessionNumber?: number;
  includedAddOnIdsForNextSession?: string[];
  provider?: {
    name?: string;
  };
  /**
   * Who initiated the package engagement. 'provider' means the provider offered
   * this package to the customer (as opposed to the customer purchasing it).
   * Absent on purchased packages — reads as 'customer'.
   */
  initiatedBy?: 'provider' | 'customer';
  /**
   * Lifecycle state of a provider-initiated package offer. Only meaningful when
   * `initiatedBy === 'provider'`. 'PENDING_ACCEPTANCE' is the only state that
   * offers the customer accept/decline actions.
   */
  offerStatus?: PackageOfferStatus;
  createdAt?: string;
  updatedAt?: string;
}

export interface ServiceGet {
  serviceId: string;
  displayId?: string;
  providerId: string;
  /**
   * The business this service listing belongs to. One provider account can
   * own multiple businesses — businessId, not providerId, is the unit a
   * customer is actually choosing between on search results (see broadcast
   * quote dedupe/swap logic in ServiceList.tsx).
   */
  businessId?: string;
  serviceTitle: string;
  businessName: string;
  businessSlug?: string;
  /** Nested business object some read paths (e.g. get-by-id) return alongside businessName. */
  business?: {
    name: string;
    businessSlug: string;
  };
  slug: string;
  categoryId: string;
  categoryName: string;
  subCategoryId: string;
  /**
   * QA-37: the payment service's tax ruleset (serviceCategoryMap) is keyed
   * by these slugs, not by categoryId/subCategoryId (internal primary
   * keys it doesn't recognize) or categoryName (display text, not a
   * stable key). null when the service's category/sub-category has no
   * slug resolved server-side -- do not fall back to categoryId/categoryName
   * when sending taxCategory, that always fails closed on the tax service.
   */
  categorySlug?: string | null;
  subCategorySlug?: string | null;
  price: number;
  isOffers: boolean;
  providerName?: string;
  review_count: number;
  avg_rating: number;
  staff: string[];
  includes?: string[];
  serviceOverview: string;
  isActive: boolean;
  isAdditional: boolean;
  isDiscount: boolean;
  isPackage: boolean;
  bookingType?: 'SLOT' | 'QUOTE' | 'PACKAGE';
  /**
   * Provider's typical response time for quote requests, in days. Surfaced on
   * the customer "Request a Quote" form as an SLA hint. Absent when the service
   * does not advertise a response time — the UI falls back to a sane default.
   */
  respondsWithinDays?: number;
  /**
   * Provider-authored scope prompts (max 6). Rendered as a static bulleted
   * checklist above the scope description box on the customer QUOTE job
   * request form. QUOTE-only; empty when the service has none.
   */
  scopePrompts?: string[];
  /**
   * Provider's quote terms and conditions, rendered on the Request a Quote
   * form as context for the customer.
   */
  quoteDetails?: string;
  packageTiers?: PackageTier[];
  additionalServices: AdditionalGet[];
  availability: AvailabilityGet[];
  location: LocationGet[];
  gallery: GalleryGet[];
  faq: [];
  seo: SeoGet[];
  discount?: DiscountGet;
  packages?: PackageGet[];
  pinned?: boolean;
  /** Sponsorship package tier — drives the Elite star on the badge. */
  badgeTier?: 'basic' | 'pro' | 'elite';
}

export interface ProviderPortalTourState {
  dismissed: boolean;
  outcome: 'completed' | 'skipped' | null;
  updatedAt: string | null;
}

export interface BusinessSummary {
  businessId: string;
  businessName: string;
  businessSlug: string;
  businessCategory: string;
  isActive: boolean;
}

/**
 * Provider business data returned by the public provider detail API
 * during the dual-write transition (Phase 1 multi-business support).
 *
 * Populated from the Business collection (authoritative) with fallback
 * to providerAccount.* (deprecated). See approved_architecture.md §2.4.D.
 */
export interface ProviderBusinessData {
  businessId: string;
  businessName: string;
  businessSlug: string;
  businessCategory?: string;
  businessEmail?: string;
  businessBio?: string;
  businessContactNo?: string;
  businessBannerImage?: string;
  businessBannerPosition?: number;
  businessProfileImage?: string;
}

export interface AuthUser {
  _id: string;
  userId: string;
  userSlug: string;
  tagLine?: string;
  isVerified: string;
  accountType: string;
  membership: string;
  enterpriseId?: string;
  verificationDocumentStatus: string;
  businessCategory: string;
  name: string;
  firstName?: string;
  lastName?: string;
  email: string;
  phoneNumber?: string;
  mobile?: string;
  phone?: string;
  dateOfBirth: string;
  role: string[];
  bio: string;
  timeZone: string;
  address: {
    addressLine1: string;
    country: string;
    state: string;
    city: string;
    postalCode: string;
    isLegalAddress: boolean;
    _id: string;
  }[];
  currencyCode: string;
  language: string;
  profilePicture: string;
  providerStatus: string;
  legalDetails: {
    firstName: string;
    middleName: string;
    lastName: string;
    docType: string;
    category: string;
    legalAddress: {
      addressLine1: string;
      country: string;
      state: string;
      city: string;
      postalCode: string;
    };
  };
  twoFactorEnabled: {
    lastUpdatedAt: string;
    IsTwoFactorEnabled: boolean;
  };
  password?: Password;
  createdAt: string;
  updatedAt: string;
  userAccount: {
    customerAccount: UserAccountProps | null;
    providerAccount: UserAccountProps | null;
    adminAccount: UserAccountProps | null;
  };

  /** Multi-business support (Phase 1) — per approved_architecture.md §4.3 */
  businessIds: string[];
  activeBusinessId: string | null;
  businesses: BusinessSummary[];

  providerPortalTour?: ProviderPortalTourState | null;
}

export interface Reply {
  id: string;
  authorName: string;
  authorAvatar?: string;
  content: string;
  date: string;
  isBusinessOwner?: boolean;
  // Nested replies
  replies?: Reply[];
  // Like system for replies
  likes: number;
  dislikes: number;
  userReaction?: 'like' | 'dislike' | null;
}

// export interface Review {
//   _id?: string;
//   id?: string;
//   reviewId?: string;
//   customerName: string;
//   customerAvatar?: string;
//   rating: number;
//   title: string;
//   comment: string;
//   formattedReviewDate: string;
//   replies: Reply[];
//   providerResponse?: ProviderResponseDisplay;
//   // Reviewer information with fallback support
//   reviewerInfo?: {
//     name?: string;
//     email?: string;
//   };
//   userName?: string;
//   name?: string;
//   userEmail?: string;
//   email?: string;
//   // Detailed ratings
//   serviceRating?: number;
//   qualityRating?: number;
//   valueRating?: number;
//   communicationRating?: number;
//   timelinessRating?: number;
//   // Service metadata
//   serviceId?: string;
//   serviceName?: string;
//   // Image data
//   imageNames?: string[];
//   imageUrls?: string[];
//   // Like/reaction system
//   likes: number;
//   dislikes: number;
//   userReaction?: 'like' | 'dislike' | null;
//   // Additional metadata
//   isVerified?: boolean;
//   createdAt: string;
//   helpfulCount?: number;
//   providerId?: string;
// }

export interface Review {
  _id?: string;
  id?: string;
  reviewId: string;
  customerId: string;
  providerId: string;
  businessId?: string;
  serviceId: string;
  bookingId: string;
  displayName: string;
  displayEmail?: string | null;
  reviewerType?: 'customer' | 'provider' | 'admin';
  isVerifiedReviewer?: boolean;
  hasProfilePicture?: boolean;
  revieweBy?: string;
  reviewerInfo?: {
    name: string;
    email?: string;
    profilePicture?: string;
    isVerified?: boolean;
    userType?: 'customer' | 'provider' | 'admin';
  };
  title: string;
  isVerified?: boolean;
  comment: string;
  rating: number; // legacy overall
  overallRating?: number;
  calculatedOverallRating?: number;
  serviceRating: number;
  qualityRating: number;
  valueRating: number;
  communicationRating: number;
  timelinessRating: number;
  reviewDate: string;
  formattedReviewDate: string;
  daysSinceReview: number;
  createdAt?: string;
  updatedAt?: string;
  imageNames: string[];
  imageUrls: string[];
  imageCount?: number;
  replies?: Reply[];
  replyCount?: number;
  hasReplies?: boolean;
  providerResponse?: ProviderResponseDisplay;
  hasProviderResponse?: boolean;
  helpfulVotesCount?: number;
  notHelpfulVotesCount?: number;
  helpfulnessPercentage?: number;
  status: 'pending' | 'approved' | 'rejected' | 'hidden';
  isVerifiedPurchase?: boolean;
  isEdited?: boolean;
  editedAt?: string;
  moderationReason?: string;
  userReaction?: 'like' | 'dislike' | null | 'helpful' | 'not_helpful';
  likes: number;
  dislikes: number;
  moderatedBy?: string;
  moderatedAt?: string;
}

export interface ProviderResponseDisplay {
  id?: string;
  _id?: string;
  reviewId?: string;
  providerId?: string;
  providerName?: string;
  responseText?: string;
  response?: string;
  responseDate?: string;
  date?: string;
  createdAt?: string;
  updatedAt?: string;
  isEdited?: boolean;
  formattedResponseDate?: string;
  timeAgo?: string;
}

export interface ReviewerInfo {
  name: string;
  email: string;
}

// Review interfaces
// export interface Review {
//   id?: string;
//   _id?: string; // MongoDB default ID field
//   reviewId?: string; // Custom review ID field (e.g., REV_000084)
//   title: string;
//   name?: string;
//   email?: string;
//   date: string;
//   rating: number;
//   review: string;
//   comment?: string;
//   response?: string; // Response from business owner
//   images: string[];
//   imageUrls: string[];
//   imageNames?: string[]; // New field for storing image names
//   profileImage?: string;
//   serviceId?: string;
//   providerId?: string;
//   bookingId?: string;
//   userId?: string;
//   userName?: string;
//   userEmail?: string;
//   userProfileImage?: string;
//   isVerified?: boolean;
//   createdAt?: string;
//   updatedAt?: string;
//   serviceName?: string;
//   serviceRating?: number;
//   qualityRating?: number;
//   valueRating?: number;
//   communicationRating?: number;
//   timelinessRating?: number;
//   providerResponse?: ProviderResponseDisplay;
//   // Backend reviewerInfo object
//   reviewerInfo?: ReviewerInfo;
// }

export interface CreateReviewData {
  providerId?: string;
  businessId?: string;
  serviceId?: string;
  bookingId?: string;
  rating: number;
  title: string;
  comment?: string;
  images?: File[];
  imageUrls?: string[];
  imageNames?: string[]; // New field for storing image names
  serviceRating?: number;
  qualityRating?: number;
  valueRating?: number;
  communicationRating?: number;
  timelinessRating?: number;
  userName?: string;
  userEmail?: string;
  userId?: string;
  userProfileImage?: string;
  isVerified?: boolean;
  date?: string;
  createdAt?: string;
  // Backend reviewerInfo object
  reviewerInfo?: ReviewerInfo;
}

export interface UpdateReviewData {
  rating?: number;
  title?: string;
  review?: string;
  comment?: string;
  images?: File[];
  imageUrls?: string[];
  imageNames?: string[]; // New field for storing image names
  serviceRating?: number;
  qualityRating?: number;
  valueRating?: number;
  communicationRating?: number;
  timelinessRating?: number;
  businessId?: string;
}

// export interface ReviewsResponse {
//   review: Review[];
//   total: number;
//   pages: number;
//   page: number;
//   limit: number;
//   averageRating?: number;
//   totalReviews?: number;
//   ratingsBreakdown?: {
//     [key: string]: number;
//   };
// }

export interface ReviewsResponse {
  success: boolean;
  message: string;
  review: Review[];
  total: number;
  pages: number;
  page: number;
  limit: number;
  data: {
    review: Review[];
    pagination: {
      currentPage: number;
      pageSize: number;
      totalReviews: number;
      totalPages: number;
    };
    sortedBy?: string;
    sortOrder?: number;
  };
  averageRating?: number;
  totalReviews?: number;
  ratingsBreakdown?: {
    [key: string]: number;
  };
}

export interface ReviewsResponseById {
  review: Review;
}

export interface PaginationParams {
  page?: number;
  limit?: number;
  userId?: string;
  rating?: number;
}

// Utility types for image handling
export interface ImageUploadResult {
  imageName: string;
  fullUrl: string;
  key: string;
  originalName: string;
  size: number;
  timestamp: number;
}

export interface ImageDisplayData {
  imageNames: string[];
  imageUrls: string[];
}

// Type for review payload sent to backend
export interface ReviewPayload {
  providerId: string;
  businessId?: string;
  serviceId: string;
  bookingId: string;
  rating: number;
  title: string;
  comment: string;
  date: string;
  serviceRating?: number;
  qualityRating?: number;
  valueRating?: number;
  communicationRating?: number;
  timelinessRating?: number;
  imageNames: string[]; // Primary field for backend storage
  imageUrls?: string[]; // Optional field for compatibility
}

export interface ReviewAnalytics {
  totalReviews: number;
  averageRating: number;
  ratingDistribution: {
    1: number;
    2: number;
    3: number;
    4: number;
    5: number;
  };
  serviceRating: number;
  qualityRating: number;
  valueRating: number;
  communicationRating: number;
  timelinessRating: number;
  monthlyTrends: Array<{
    month: string;
    count: number;
    averageRating: number;
  }>;
}

export interface OverallRating {
  providerId?: string;
  businessId?: string;
  serviceId?: string;
  averageRating: number;
  totalReviews: number;
  ratingBreakdown: {
    serviceRating: number;
    qualityRating: number;
    valueRating: number;
    communicationRating: number;
    timelinessRating: number;
  };
}

export interface MultipleRatingsRequest {
  providerIds?: string[];
  businessIds?: string[];
  serviceIds?: string[];
}

export interface MultipleRatingsResponse {
  ratings: Array<{
    id: string;
    type: 'provider' | 'service';
    averageRating: number;
    totalReviews: number;
  }>;
}

// Provider Response interfaces
export interface ProviderResponse {
  id?: string;
  _id?: string;
  reviewId: string;
  providerId: string;
  providerName: string;
  response: string;
  date: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateProviderResponseData {
  responseText: string;
  providerName: string;
  providerId: string;
}

export interface Booking {
  businessName: string;
  id: number | string;
  service: string;
  serviceName?: string; // Alternative field name for service
  status:
    | 'Pending'
    | 'Confirmed'
    | 'Finished'
    | 'Cancelled'
    | 'Completed'
    | 'InProgress'
    | 'Rescheduled';
  date: string;
  amount: string;
  total: number | string;
  payment: string;
  paymentMethod?: string; // Alternative field name for payment
  location: string;
  provider: string;
  providerName?: string;
  email: string;
  phone: string;
  actions: string[];
  providerId?: string;
  bookingId?: string;
  serviceId?: string;
  displayId?: string;
  createdAt?: string;
  price?: number | string;
  bookingType?: 'Slot' | 'PackageSession';
  sessionsRemaining?: number;
  sessionsTotal?: number;
  sessionsUsed?: number;
  serviceImages?: string[]; // Array of service image URLs
  description?: string; // Service description
  duration?: string; // Service duration
  category?: string; // Service category
  staffName?: string;
  staff?: {
    name?: string;
    fullName?: string;
  };
  personalInfo?: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    streetAddress?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    notes?: string;
    address?: {
      street?: string;
      city?: string;
      state?: string;
      postalCode?: string;
      country?: string;
    };
  };
  serviceDetails?: {
    serviceTitle?: string;
    displayId?: string;
    categoryId?: string;
    subCategoryId?: string;
    price?: number;
    isOffers?: boolean;
    isAdditional?: boolean;
    staff?: unknown;
    availableDate?: unknown;
  };
  referenceCode?: string; // Booking reference code
  additionalServices?: {
    id?: string;
    name?: string;
    price?: number;
    duration?: string;
    description?: string;
  }[]; // Array of additional services
  appointmentTimeFrom?: string; // Appointment start time
  appointmentTimeTo?: string; // Appointment end time
  appointmentDate?: string; // Appointment date
  bookingStatus?: string; // Detailed booking status information
  gallery?: {
    id?: string;
    serviceImages?: string[];
    videoLink?: string;
  }[]; // Gallery array containing service images and videos
  completionDeadline: string | null;
  customerMarkedCompleted: boolean;
  customerMarkedCompletedDate: string | null;
  providerMarkedCompleted: boolean;
  providerMarkedCompletedDate: string | null;

  subtotal: number;
  tax: number;
  discount: number;
  note?: string;
  auditLogs?: { action: string; performedBy: string; timestamp: string }[];
  cancelledNote?: string;
  rescheduledNote?: string;
  cancelledAt?: string;
  rescheduledAt?: string;
  providerEmail: string;
  providerMobile: string;
  staffEmail: string;
  hasProvReviewed: boolean;
  hasCusReviewed: boolean;

  // ── Provider-created online-payment booking (pay page) ────────────────
  // A booking a provider created on a customer's behalf with paymentMethod
  // 'Stripe'. Starts PENDING_CAPTURE with isProviderCreated: true, rests there
  // until the customer explicitly accepts (customerAcceptedAt) and pays; a
  // sweep cancels it after paymentExpiresAt (48h).
  isProviderCreated?: boolean;
  customerAcceptedAt?: string | null;
  paymentExpiresAt?: string | null;
  /** Stamped at creation — acceptance is implied by the provider for their own bookings. */
  providerAcceptanceDate?: string | null;
  isPaid?: boolean;
  _id?: string;
  customerId?: string;
  timeSlotId?: string;
}

// types/notification.ts (Updated)
export type NotificationType =
  | 'system'
  | 'message'
  | 'comment'
  | 'like'
  | 'mention'
  | 'alert'
  | 'other';
export type NotificationPriority = 'critical' | 'high' | 'medium' | 'low';

export interface Notification {
  _id: string;
  id: string;
  userId: string;
  role: string;
  templateId?: string;
  templateName?: string;
  sendType?: string;
  scheduledAt?: string;
  title: string;
  message: string;
  priority: NotificationPriority;
  type: NotificationType;
  targetType: string;
  targetRole?: string;
  read?: boolean;
  isRead?: boolean;
  relatedEntity?: any;
  data?: any;
  expiresAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginationInfo {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface NotificationResponse {
  data: Notification[];
  pagination: PaginationInfo;
}

export interface FilterOptions {
  type?: string;
  priority?: string;
  readStatus?: string;
  search?: string;
  sortDirection?: 'newest' | 'oldest';
  limit?: number;
  page?: number;
}

export interface NotificationActionResponse {
  success: boolean;
  message?: string;
  data?: any;
}

export type UserAccountProps = {
  accountId: string;
  accountType: 'customer' | 'provider' | 'admin';
  state:
    | 'active'
    | 'inactive'
    | 'suspended'
    | 'pending_deletion'
    | 'deleted'
    | 'deactivated';
  accountCreateAt: string;
};

export interface ServiceSuggestion {
  serviceId: string;
  serviceTitle: string;
  slug: string;
}

export interface ServiceSuggestionsResponse {
  success: boolean;
  suggestions: ServiceSuggestion[];
}

/**
 * Tracks how a search query was submitted — typed manually or selected from a
 * suggestion dropdown.  Used for measuring dropdown adoption.
 *
 * 'popular' is reserved for a future server-side trending-searches slice;
 * the enum value exists now so analytics instrumentation doesn't need a
 * schema change later.
 */
export type SuggestionSource = 'typed' | 'recent' | 'popular';

export interface ConciergeSearchRequest {
  query: string;
  latitude?: number;
  longitude?: number;
  radius?: number;
  categories?: string[];
  subCategory?: string;
  minRating?: number;
  priceRange?: number[];
  includeOnline?: boolean;
}

export interface PopularSearchItem {
  text: string;
  count: number;
}

export interface SearchSuggestionsResponse {
  success: boolean;
  data: {
    popular: PopularSearchItem[];
  };
}

export interface ConciergeSearchMatch extends Partial<ServiceGet> {
  matchPct: number | null;
}

export interface ConciergeSearchResponse {
  success: boolean;
  data: {
    interpretedQuery: {
      keywords: string[];
      categoryGuess: string | null;
      urgency: string | null;
      priceHint: string | null;
      usedFallback: boolean;
    };
    matches: ConciergeSearchMatch[];
    onlineMatches?: ConciergeSearchMatch[];
  };
}

export interface IBookingQuery {
  fullProfile: boolean;
  ownerId: string;
  withMongoId: boolean;
  filters?: { [key: string]: any };
  bookingProjection?: string;
  serviceProjection?: string;
  staffProjection?: string;
  isVisible?: boolean;
  isDeleted?: boolean;
  page?: number;
  limit?: number;
}

export interface IServiceQuery {
  fullProfile: boolean;
  ownerId?: string;
  withMongoId: boolean;
  filters?: { [key: string]: any };
  serviceProjection?: string;
  categoryProjection?: string;
  subcategoryProjection?: string;
  staffProjection?: string;
  providerProjection?: string;
  businessProjection?: string;
  faqProjection?: string;
  seoProjection?: string;
  availabilityProjection?: string;
  additionalServiceProjection?: string;
  galleryProjection?: string;
  locationProjection?: string;
  isVisible?: boolean;
  isDeleted?: boolean;
  page?: number;
  limit?: number;
}

export type ServiceCardType = Pick<
  ServiceGet,
  | 'serviceId'
  | 'providerId'
  | 'businessId'
  | 'slug'
  | 'categoryId'
  | 'providerName'
  | 'businessName'
  | 'categoryName'
  | 'price'
  | 'serviceTitle'
  | 'gallery'
  | 'isDiscount'
  | 'isPackage'
  | 'bookingType'
  | 'location'
  | 'packages'
  | 'discount'
> & {
  displayId?: string;
  category: {
    categoryId: string;
    categoryName: string;
  };
  provider: {
    name: string;
    userId: string;
    businessName: string;
  };
  business: {
    name: string;
    businessSlug: string;
  };
  review_count?: number;
  avg_rating?: number;
  pinned?: boolean;
  /** Sponsorship package tier — drives the Elite star on the badge. */
  badgeTier?: 'basic' | 'pro' | 'elite';
};
